import React, {useContext} from "react";
import {useSelector} from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";
import EditorialItem from "../../../EditorialItem";
import {editContentAnchors} from "../../../../pages/Home/utils/utils";
import {PortalConfigContext} from "../../../../config/portal";
import {getAssetUrl} from "../../../../utils/commonHelper";
import {getSeoDataItems} from "../../../../utils/seo";

import './styles.css';

const FooterDynamicLink = (props) => {
    const portalContext = useContext(PortalConfigContext);
    const { context } = props;
    const logoAlt = portalContext.fullName;
    const seoContent = useSelector(state => state?.app?.data?.seoContent || []);
    const seoListItems = getSeoDataItems(seoContent, 'footer-links');

    const parseEditorialItem = (content) => {
        return editContentAnchors(content, portalContext.pages.home.seoConfig);
    };

    return (
        seoListItems.length > 0 ? (
            <div className={classnames('footer-links')}>
                <div className={classnames('footer-links-container')}>
                    {context?.logo?.showLogo &&
                        <img className="logo" src={getAssetUrl(context.logo.url)} alt={logoAlt} />}
                    {seoListItems.map((list, index) => {
                        return (
                            <EditorialItem
                                header={list.title}
                                content={parseEditorialItem(list.html)}
                                key={index}
                                classOverride={'quicklink-list'}
                            />
                        );
                    })}
                </div>
            </div>
        ) : null
    );
};

FooterDynamicLink.propTypes = {
    context: PropTypes.object
};

export default FooterDynamicLink;
